import React from 'react'
import { Link } from 'react-router-dom'
import AppHeader from '../AppHeader'
import { ContentPaste, Notifications } from '@mui/icons-material'

function DashboardComponent() {
  return (
    <>
        <AppHeader/>
        <div className='container'>
            <div className='row mt-5 text-center'>
                <div className='col-md-4 my-3'>
                    <div className='card border border-success p-3 ' >
                        <Link to={"/checkin/queue"} className='btn text-success btn-lg'>
                            <h3></h3>
                            <p>Book token for today</p>
                            <p>आज के लिए अपना टोकन बुक करें।</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-4 my-3'>
                    <div className='card bg-success p-3 ' >
                        <Link to={"/schedule-checkin/queue"} className='btn text-white btn-lg'>
                            <h3></h3>
                            <p>Book token for upcoming days </p>
                            <p>आगामी दिनों के लिए टोकन प्राप्त करें।</p>
                        </Link>
                    </div>
                </div>
                <div className='col-md-4 my-3'>
                    <div className='card bg-primary p-3 ' >
                        <Link to={"/token-details"} className='btn text-white btn-lg'>
                            <h3></h3>
                            <p>Your Token List </p>
                            <p>आपके टोकन का विवरण</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-4 my-3'>
                    <div className='card bg-danger p-3 ' >
                        <Link to={"/notification-list"} className='btn text-white btn-lg'>
                            <h3><Notifications /></h3>
                            <p> </p>
                            <p>Notifications / संदेश</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-4 my-3'>
                    <div className='card bg-warning p-3 ' >
                        <Link to={"/customer-profiles"} className='btn btn-lg'>
                            <h3><ContentPaste/></h3>
                            <p></p>
                            <p>Records /आपके रेकार्ड</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-4 my-3'>
                    <div className='card bg-dark p-3 ' >
                        <Link to={"/followup-list"} className='btn text-white btn-lg'>
                            <h3><ContentPaste/></h3>
                            <p></p>
                            <p>Follow Up / फ़ॉलो-अप</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default DashboardComponent